// extracted by mini-css-extract-plugin
export default {"mainButton":"button_mainButton__qNZgC","greenButton":"button_greenButton__gZRf6","ghostButton":"button_ghostButton__A9PbI","secondaryButton":"button_secondaryButton__MJUKM"};